import React from 'react';
import {
  UcatTimedPreScreen,
  UcatSubtestTable,
  ucatBodyText,
} from './UcatTimedPreScreen';
import { ucatSubtestsOverviewCopy, ucatTopicOverviewRows } from '../utils/ucatTopicOverviewRows';

/** Screenshot 2 — four-subtest overview table (2 minutes), or one-subtest practice. */

const UcatSubtestsOverviewScreen = ({ paperTitle, colorScheme, setColorScheme, onNext, onEndExam, pearsonSitting = false, pearsonModules = [] }) => {
  const copy = ucatSubtestsOverviewCopy(pearsonModules);
  return (
    <UcatTimedPreScreen
      examName="UCAT"
      paperTitle={paperTitle}
      colorScheme={colorScheme}
      setColorScheme={setColorScheme}
      onNext={onNext}
      onEndExam={onEndExam}
      durationSeconds={copy.durationSeconds}
      showHelp
      showEndExam={false}
      pearsonSitting={pearsonSitting}
    >
      {({ ink, scheme }) => {
        const body = ucatBodyText(ink);
        const rows = ucatTopicOverviewRows(pearsonModules);
        return (
          <>
            <p style={{ ...body, fontWeight: 700 }}>
              {copy.leadIn}
            </p>
            <p style={body}>{copy.consistsOf}</p>
            <UcatSubtestTable ink={ink} scheme={scheme} rows={rows} />
            <p style={body}>
              Refer to the <strong>Help</strong> button for guidance on problems during testing. Test time will continue to count down while using the Help button.
            </p>
            <p style={{ ...body, marginBottom: 0 }}>
              Please click the{' '}
              <strong>
                Next (<span style={{ textDecoration: 'underline' }}>N</span>)
              </strong>{' '}
              button to proceed before the time on this screen expires.
            </p>
          </>
        );
      }}
    </UcatTimedPreScreen>
  );
};

export default UcatSubtestsOverviewScreen;
